import React, { useContext, useState } from 'react';
import Moment from 'react-moment';
import {useParams} from "react-router-dom";

import firebase from "../config/firebase";
import Download from "./Download.js";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import DeleteIcon from '@material-ui/icons/Delete';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { makeStyles } from '@material-ui/core/styles';
import { Container , Grid , Link, Button, Dialog, 
         DialogContent, DialogTitle, DialogContentText, DialogActions,
        FormControl, InputLabel, Select, TextField
        } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import CircularProgress from '@material-ui/core/CircularProgress';

import {CopyToClipboard} from 'react-copy-to-clipboard';
import { AuthContext } from '../Auth.js' 


const handlelogout = () => {
    firebase.auth().signOut().then(function() {
    }).catch(function(error) {
        console.log(error)
    });
  };

const useStyles = makeStyles((theme) => ({
    root: {
    flexGrow: 1,
    margin:theme.spacing(0),
    padding:theme.spacing(0),
    },
    title: {
    flexGrow: 1,
    textAlign:'left'
    }, 
    button: {
        margin: theme.spacing(1),
        float: 'right'
    },
    imgLogo: {
        width: "50px",
        marginRight: theme.spacing(1)
      },
    nested: {
        paddingLeft: theme.spacing(4),
      },
 }));




function GetHeaderBase ()  {
    const classes = useStyles();
    return (
    <>
    <AppBar position="sticky" color="default" 
        >
        <Toolbar id="back-to-top-anchor" >
           <IconButton href="/" color="secondary">
                <ArrowBackIcon /> 
           </IconButton>
           <img className={classes.imgLogo} src={require('../assets/img/logo.png')} />
          <Typography className={classes.title} variant="h6">Unidos para Ayudar</Typography>
        </Toolbar>
      </AppBar>
    </>
    );
} 


function DayDetail (props) {
    const {dayId} = useParams();
    const classes = useStyles();
    const {currentUser, userProfile } = useContext(AuthContext);

    const [open, setOpen] = useState([false, false, false, false]);
    const [dia, setDia] = useState(null);
    const [turnos, setTurnos] = useState(null)
    const [voluntarios1, setVoluntarios1] = useState(null);
    const [voluntarios2, setVoluntarios2] = useState(null);
    const [voluntarios3, setVoluntarios3] = useState(null);
    const [turnoABloquear, setTurnoABloquear] = useState("");
    const [NuevoBloqueante, setNuevoBloqueante] = useState("")
    const [openBloquearTurno, setOpenBloquearTurno] = useState(false);


    const handleClick = (index) => {
        let newOpen = [...open]; 
        newOpen[index] = !open[index]; // replace e.target.value with whatever you want to change it to
        setOpen(newOpen);
    };

    const handleDelete = (turno, volId) => {
        const db = firebase.firestore().collection('orgs').doc('unidos');
        var volTurnoRef = db.collection('dias').doc(dayId).collection('turnos').doc(turno).collection('voluntarios').doc(volId)
        const id = dayId + "_" + turno
        var volTurnoRef2 = db.collection('users').doc(volId).collection('turnos').doc(id)
        var auditRef    = db.collection('audits').doc()
        var audit = {
            'userId'        : currentUser.uid,
            'userNombre'    : userProfile.nombre + " " + userProfile.apellido,
            'created'       :  firebase.firestore.FieldValue.serverTimestamp(),
            'movimiento'    : "Baja Voluntario",
            'dia'           : dayId, 
            'turno'         : turno,
            'voluntarioId'  : volId
        }
        return firebase.firestore().runTransaction(function(transaction) {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(volTurnoRef).then(function(userDoc) {
                if (!userDoc.exists) {
                    throw "User does not exist!";
                }
                transaction.delete(volTurnoRef);   
                transaction.delete(volTurnoRef2);
                transaction.set(auditRef, audit);
            })
        }).then(function() {
        }).catch(function(error) {
            console.log("Transaction failed: ", error);
        });
    }

    React.useEffect(() => {

        const listenVoluntariosPorTurnoUno = () => {
            firebase.firestore().collection('orgs').doc('unidos')
              .collection('dias')
              .doc(dayId).collection('turnos').doc("1")
              .collection('voluntarios')
              .onSnapshot((snapshot) => {
                  setVoluntarios1(snapshot.docs.map(x => ({...x.data(), id:x.id})));
            }, (error) => console.error(error));
        };
    
        const listenVoluntariosPorTurnoDos = () => {
            firebase.firestore().collection('orgs').doc('unidos')
              .collection('dias')
              .doc(dayId).collection('turnos').doc("2")
              .collection('voluntarios')
              .onSnapshot((snapshot) => {
                  setVoluntarios2(snapshot.docs.map(x => ({...x.data(), id:x.id})));
            }, (error) => console.error(error));
        };

        const listenVoluntariosPorTurnoTres = () => {
            firebase.firestore().collection('orgs').doc('unidos')
              .collection('dias')
              .doc(dayId).collection('turnos').doc("3")
              .collection('voluntarios')
              .onSnapshot((snapshot) => {
                  setVoluntarios3(snapshot.docs.map(x => ({...x.data(), id:x.id})));
            }, (error) => console.error(error));
        };
    
        const fetchData = async () => {
            const db = firebase.firestore().collection('orgs').doc('unidos');
            db.collection("dias")
            .doc(dayId)
            .get()
            .then(function(doc) {
                if (doc.exists) {
                    const fecha = doc.data().fecha.toDate();
                    setDia(fecha);
                } else {
                    console.log("no existe")
                }

            });
        };
        fetchData();
        const fetchDataTurnos = async () => {
            const db = firebase.firestore().collection('orgs').doc('unidos');
            const data = await db.collection("dias")
            .doc(dayId).collection('turnos')
            .get()
            setTurnos(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        };
        fetchDataTurnos();
        listenVoluntariosPorTurnoUno();
        listenVoluntariosPorTurnoDos();
        listenVoluntariosPorTurnoTres();
    }, []);

    const handleDesbloquearTurno = (turnoId) => {
        try {
            firebase.firestore().collection('orgs').doc('unidos')
                .collection('dias')
                .doc(dayId)
                .collection('turnos')
                .doc(turnoId)
                .update({
                  "bloqueado"  : false,
                  "bloqueante" : "",
                  "updated"    : firebase.firestore.FieldValue.serverTimestamp(),
                  "userUpdate" : currentUser.uid
                });
                alert("Refresca la pagina para ver los cambios")
        } catch (error) {
            alert(error);
        }
    }

    const renderCabezalTurno = (turnoIndex) => {
        if (turnoIndex === 0) {
            if (!voluntarios1) {
                return (
                    "Turno " + turnos[0].horario 
                )
            } else {
                return (
                    "Turno " + turnos[0].horario + "(" + voluntarios1.length + " de " + turnos[0].maximo + ")"
                )
            }
        } 
        if (turnoIndex === 1) {
            if (!voluntarios2) {
                return (
                    "Turno " + turnos[1].horario 
                )
            } else {
                return (
                "Turno " + turnos[1].horario + "(" + voluntarios2.length + " de " + turnos[1].maximo + ")"
                )
            }
        }
        if (turnos[2]) {
            if (turnoIndex === 2) {
                if (!voluntarios3) {
                    return (
                        "Turno " + turnos[2].horario 
                    )
                } else {
                    return (
                    "Turno " + turnos[2].horario + "(" + voluntarios3.length + " de " + turnos[2].maximo + ")"
                    )
                }
            }  
        } 
        return ;
    };

    const renderVoluntarios = (turno) => {
        
        if (!turnos[turno-1])
            return (<></>)
        
        let bloqueado;
        if (typeof turnos[turno-1].bloqueado === "undefined") {
            bloqueado = false;
        } else {
            bloqueado = turnos[turno-1].bloqueado
        }
        if (!bloqueado) {
            if (turno === 1) {
                if (!voluntarios1)
                    return (
                        <>
                        <ListItemText primary="Cargando" />
                        </>
                    )
                if (!voluntarios1.length)
                    return (
                        <>
                        <ListItemText primary="No hay voluntarios" />
                        </>
                    )
                const listItems = voluntarios1.map((d, index) => {
                    if (!d.verificado)
                        d.verificado = false;
                    return(
                    <Grid  container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    key={index}>
                        <Grid item xs >
                            {index+1}
                        </Grid>
                        <Grid item xs >
                            <Button onClick={() => handleDelete(turnos[turno-1].id, d.id)} >
                                <DeleteIcon />
                            </Button>
                        </Grid>
                        <Grid item xs >
                        <span style={{color: d.verificado ? "#000000" : "#CC0000" }}>
                            {d.nombre}
                            </span>
                        </Grid>
                        <Grid item xs >
                        <span style={{color: d.verificado ? "#000000" : "#CC0000" }}>
                            {d.apellido}
                            </span>
                        </Grid>   
                        <Grid item xs >
                            <Link  style={{color: 'inherit', textDecoration: 'inherit'}} href={"tel:" + d.celular}>
                            {d.celular}
                            </Link>
                        </Grid>
                    </Grid>
                    )
                });
                return (
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                        {listItems}
                    </Grid>
                )
            }
            if (turno === 2) {
                if (!voluntarios2)
                    return (
                        <>
                        <ListItemText primary="Cargando" />
                        </>
                    )
                if (!voluntarios2.length)
                    return (
                        <>
                        <ListItemText primary="No hay voluntarios" />
                        </>
                    )
                const listItems = voluntarios2.map((d, index) => {
                    if (!d.verificado)
                        d.verificado = false;
                    return(
                        <Grid  container
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        key={index}>
                        <Grid item xs >
                            {index+1}
                        </Grid>
                        <Grid item xs >
                            <Button onClick={() => handleDelete(turnos[turno-1].id, d.id)} >
                                <DeleteIcon />
                            </Button>
                        </Grid>
                        <Grid item xs >
                        <span style={{color: d.verificado ? "#000000" : "#CC0000" }}>
                            {d.nombre}
                        </span>
                        </Grid>
                        <Grid item xs >
                        <span style={{color: d.verificado ? "#000000" : "#CC0000" }}>
                            {d.apellido}
                        </span>
                        </Grid>   
                        <Grid item xs >
                            <Link  style={{color: 'inherit', textDecoration: 'inherit'}} href={"tel:" + d.celular}>
                            {d.celular}
                            </Link>
                        </Grid>
                    </Grid>
                    )
                });
                return (
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                        {listItems}
                    </Grid>
                )
            }
            if (turno === 3) {
                if (!voluntarios3)
                    return (
                        <>
                        <ListItemText primary="Cargando" />
                        </>
                    )
                if (!voluntarios3.length)
                    return (
                        <>
                        <ListItemText primary="No hay voluntarios" />
                        </>
                    )
                const listItems = voluntarios3.map((d, index) => {
                    if (!d.verificado)
                        d.verificado = false;
                    return(
                        <Grid  container
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        key={index}>
                        <Grid item xs >
                            {index+1}
                        </Grid>
                        <Grid item xs >
                            <Button onClick={() => handleDelete(turnos[turno-1].id, d.id)} >
                                <DeleteIcon />
                            </Button>
                        </Grid>
                        <Grid item xs >
                        <span style={{color: d.verificado ? "#000000" : "#CC0000" }}>
                            {d.nombre}
                        </span>
                        </Grid>
                        <Grid item xs >
                        <span style={{color: d.verificado ? "#000000" : "#CC0000" }}>
                            {d.apellido}
                        </span>
                        </Grid>   
                        <Grid item xs >
                            <Link  style={{color: 'inherit', textDecoration: 'inherit'}} href={"tel:" + d.celular}>
                            {d.celular}
                            </Link>
                        </Grid>
                    </Grid>
                    )
                });
                return (
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                        {listItems}
                    </Grid>
                )
            }
        } else {
            return (
                <>
                <Grid container alignItems="center">
                <Grid item> 
                    <Button onClick={() => handleDesbloquearTurno(turnos[turno-1].id)}>
                        <LockOpenIcon />
                    </Button>
                </Grid>
                <Grid item> 
                    <ListItemText primary={"Turno bloqueado para " + turnos[turno-1].bloqueante } />
                </Grid>
                </Grid>
                </>
            )
        }
    }

    const handleBloquearTurnoOpen = () => {
        setOpenBloquearTurno(true);
    };

    const handleBloquearTurnoClose = () => {
        setOpenBloquearTurno(false);
    };

    const handleBloquearTurnoConfirm = (event) => {
        event.preventDefault();
        try {
        firebase.firestore().collection('orgs').doc('unidos')
            .collection('dias')
            .doc(dayId)
            .collection('turnos')
            .doc(turnoABloquear)
            .update({
              "bloqueado"  : true,
              "bloqueante" : NuevoBloqueante,
              "updated"    : firebase.firestore.FieldValue.serverTimestamp(),
              "userUpdate" : currentUser.uid
            });
            alert("Refresca la pagina para ver los cambios")
        } catch (error) {
          alert(error);
        }
        setNuevoBloqueante("")
        setTurnoABloquear("")
        setOpenBloquearTurno(false);
    }

    const renderExport = () => { 
        const vols1 = JSON.parse(JSON.stringify(voluntarios1, ['nombre', 'celular', 'cedula', 'email', 'verificado']));
        const vols2 = JSON.parse(JSON.stringify(voluntarios2, ['nombre', 'celular', 'cedula', 'email', 'verificado']));
        const vols3 = JSON.parse(JSON.stringify(voluntarios3, ['nombre', 'celular', 'cedula', 'email', 'verificado']));
        const formattedDate = dia.toISOString().slice(0,10);
        return (
            <Grid container justify="flex-end">
                <Grid item>
                    <br/>
                    <Download 
                        filename={formattedDate}
                        voluntarios1={vols1}
                        voluntarios2={vols2}
                        voluntarios3={vols3}
                    />
                </Grid>
            </Grid>
        )
    }


    const handleTurnoABloquearChange = (event) => {
        setTurnoABloquear(event.target.value)
    }

    const handleChangeNuevoBloqueante = (event) => {
        setNuevoBloqueante(event.target.value)
    }

    if (!userProfile || !dia || !turnos) {
        return(
            <>
            <GetHeaderBase />
            <br></br>
            <Container spacing={2}>
            <CircularProgress />
            </Container>
            </>
        )
    }

    if (!userProfile.organizador) {
        return(
            <>
            <GetHeaderBase />
            <br></br>
            <Container spacing={2}>
            No tiene permisos para ver el detalle
            </Container>
            </>
        )
    }

    return (
        <>
        <GetHeaderBase />
        <br></br>
        <Container spacing={2}>
            <Grid container direction="row" justify="space-between" alignItems="center">
                <Grid item>
                <Typography  variant="h6" >
                <Moment format="DD/MM">{dia}</Moment> - Voluntarios 
                </Typography>
              </Grid>
              <Grid item>
                <Button color="secondary" size="small" onClick={handleBloquearTurnoOpen}>
                  <LockIcon />
                </Button>
              </Grid>
              <Dialog open={openBloquearTurno} onClose={handleBloquearTurnoClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Bloquear Turno</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                  <form className={classes.container} noValidate>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel htmlFor="outlined-turno-native-simple">Turno</InputLabel>
                        <Select
                        native
                        value={turnoABloquear}
                        onChange={handleTurnoABloquearChange}
                        label="Turno"
                        inputProps={{
                            name: 'turno',
                            id: 'outlined-turno-native-simple',
                        }}
                        >
                        <option aria-label="None" value="" />
                        <option value={"1"}>{turnos[0].horario}</option>
                        <option value={"2"}>{turnos[1].horario}</option>
                        <option value={"3"}>{turnos[2].horario}</option>
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <TextField id="bloqueante" label="Grupo" variant="outlined" onChange={handleChangeNuevoBloqueante} value={NuevoBloqueante}/>
                    </FormControl>
                  </form>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleBloquearTurnoClose} color="primary">
                    Cancelar
                  </Button>
                  <Button onClick={handleBloquearTurnoConfirm} color="primary">
                    Confirmar
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}
            >
            <ListItem button onClick={() => handleClick(0)}>
                <ListItemText primary={renderCabezalTurno(0)} />
                {open[0] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open[0]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                <ListItem className={classes.nested}>
                    {renderVoluntarios(1)}
                </ListItem>
                </List>
            </Collapse>
            <Divider />
            <ListItem button onClick={() => handleClick(1)}>
                <ListItemText primary={renderCabezalTurno(1)} />
                {open[1] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open[1]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                <ListItem  className={classes.nested}>
                    {renderVoluntarios(2)}
                </ListItem>
                </List>
            </Collapse>
            <Divider />
            <ListItem button onClick={() => handleClick(2)}>
                <ListItemText primary={renderCabezalTurno(2)} />
                {open[2] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open[2]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                <ListItem  className={classes.nested}>
                    {renderVoluntarios(3)}
                </ListItem>
                </List>
            </Collapse>
            <Divider />
            </List>
        </Container>
        { renderExport() }
        </>
    )
}

export default DayDetail;